import React, { useState, useEffect } from "react";
import { Card } from "components/shadcn/ui/card";
import { Button } from "components/shadcn/ui/button";

const HGStepper = ({ steps, children, onFinish }) => {
  const activeStepForEditing = JSON.parse(sessionStorage.getItem("activeStep"));
  const [activeStep, setActiveStep] = useState(activeStepForEditing ?? 0);
  const { title, content } =
    steps[activeStep < steps.length ? activeStep : steps.length - 1];
  useEffect(() => {
    if (activeStep === steps.length - 2) {
      sessionStorage.setItem("activeStep", JSON.stringify(activeStep));
    }
  }, [activeStep, steps]);

  return (
    <Card className="p-3">
      <div className="mb-5">
        <div className="grid grid-cols-6 gap-3 mb-2">
          {steps?.map(({ label }) => {
            return (
              <p key={label} className="text-sm text-center">
                {label}
              </p>
            );
          })}
        </div>
        <div className="w-full h-[5px] rounded bg-gray-300 dark:bg-gray-600">
          <div
            className="h-full rounded transition-transform duration-300 bg-info"
            style={{
              width: "16.666%",
              transform: `translateX(${activeStep * 100}%)`,
            }}
          />
        </div>
      </div>
      <div className="mb-5">
        {children(activeStep, title, content, setActiveStep)}
      </div>
      <div className="w-full flex justify-between">
        <Button
          variant="outline"
          onClick={() => setActiveStep(activeStep - 1)}
          disabled={activeStep === 0}
        >
          back
        </Button>
        {activeStep < 4 && (
          <Button
            variant="outline"
            onClick={() => setActiveStep(activeStep + 1)}
            disabled={activeStep === steps.length - 1}
          >
            next
          </Button>
        )}
        {activeStep === 5 && (
          <Button
            variant="outline"
            onClick={() => onFinish()}
          >
            Complete
          </Button>
        )}
      </div>
    </Card>
  );
};

export default HGStepper;
